import { render, staticRenderFns } from "./CashboxJournal.vue?vue&type=template&id=31d239a0&"
import script from "./CashboxJournal.vue?vue&type=script&lang=js&"
export * from "./CashboxJournal.vue?vue&type=script&lang=js&"
import style0 from "./CashboxJournal.vue?vue&type=style&index=0&id=31d239a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports